import {
    Box,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import { useRef } from "react";
import { useQuery } from "@apollo/client";
import { REVIEW_REASONS } from "@/graphql/queries/warning";

export default function WarningReviewReasonList({
    search,
    reason: selectedReason,
    setReason,
    customReason,
    setCustomReason,
}) {
    const { data: { reviewReasons } = {}, loading } = useQuery(REVIEW_REASONS);

    let reasons = [...(reviewReasons ?? [])];
    if (search) {
        reasons = reasons?.filter((r) => r.text.indexOf(search) > -1);
    }

    const displayPlaceholder = search != "" && reasons?.length === 0;

    if (loading) {
        return <CircularProgress />;
    }

    if (displayPlaceholder) {
        return (
            <Box
                sx={{
                    width: "100%",
                    minHeight: "200px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px 16px",
                }}
            >
                <Typography
                    sx={{
                        color: "#2B2B2B",
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    دلیلی با این کلیدواژه یافت نشد
                </Typography>
                <Box height="24px" />
                <Typography
                    sx={{
                        fontSize: "1rem",
                        color: "#454446",
                        textAlign: "center",
                    }}
                >
                    دلیل خود را بدون جست‌وجو از لیست پیدا کنید
                </Typography>
            </Box>
        );
    }

    return (
        <FormControl
            fullWidth
            sx={{
                maxHeight: "250px",
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            <RadioGroup>
                {reasons.map((reason, idx) => {
                    const isChecked =
                        reason.reasonId === selectedReason?.reasonId;
                    let color = "#212121";
                    if (isChecked) {
                        color = "#175EE4";
                    }

                    let label = <Typography>{reason.text}</Typography>;

                    return (
                        <FormControlLabel
                            key={idx}
                            onChange={(_, selected) => {
                                if (selected) {
                                    setReason(reason);
                                }
                            }}
                            control={<Radio checked={isChecked} />}
                            label={label}
                            sx={{
                                display: "flex",
                                alignItems: "start",
                                width: "100%",
                                ".MuiFormControlLabel-label": {
                                    width: "100%",
                                },
                                ".MuiTypography-root": {
                                    padding: "8px 0",
                                    fontSize: "0.875rem",
                                    color: color,
                                    fontWeight: isChecked ? "bold" : "normal",
                                },
                            }}
                        />
                    );
                })}
            </RadioGroup>
        </FormControl>
    );
}
